module.exports = __webpack_public_path__ + "img/prepaid50-pl.52421cdb.svg";